import React from "react";
import { AccordionPanel } from "@chakra-ui/react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { options } from "api/contentful/options";

interface Props {
  topic: any;
}

const Topic: React.FC<Props> = ({ topic }: Props) => {
  return (
    <AccordionPanel px={12} pt={3} pb={6}>
      {topic.content && documentToReactComponents(topic.content, options)}
    </AccordionPanel>
  );
};

export default Topic;
